import React from "react";

export const SignupNav = ({ logo, logoName }) => {
  return <img src={logo} alt={logoName} />;
};
